/**
 * @fileoverview ContractorConst const<br>
 * 本ファイルは定義書より出力されるため直接編集禁止<br>
 * 変更がある場合は定義書を変更しファイルを生成してください。
 */
'use strict';
const ContractorConst = {
  /**
   * 利用状況
   * @name USE_STATUS_LIST
   * @constant
   * @memberOf const.ContractorConst
   */
  USE_STATUS_LIST: {
    DISABLED: '0',
    FREE: '1',
    PART_FREE: '2',
    FULL: '3'
  },

  /**
   * 配送業者状態
   * @name CONTRACTOR_STATUS_LIST
   * @constant
   * @memberOf const.ContractorConst
   */
  CONTRACTOR_STATUS_LIST: {
    AVAILABLE: '1',
    UNAVAILABLE: '2'
  },

  /**
   * 予約登録結果コード
   * @name REQUEST_REGIST_RESULT
   * @constant
   * @memberOf const.ContractorConst
   */
  REQUEST_REGIST_RESULT: {
    // 成功
    SUCCESS: '1',
    // バース種別が無効
    INVALID_BERTH_CATEGORY: '2',
    // バースがすべて無効
    INVALID_BERTH: '3',
    // 利用可能日・時間外
    OUTSIDE: '4',
    // 予約枠超過
    FULL: '5',
    // 予約可能日範囲外
    BOOKING_PERIOD_OUTSIDE: '7',
    // 車種が無効
    INVALID_CAR_MODEL: '8',
    // その他エラ－
    OTHER: '9',
    // 配送会社名が無効
    CONTRACTOR_ID_ERROR: '10',
    // 予約期間エラー
    OUTSIDE_TIME: '11',
    // 開始予定時刻チェック
    START_TIME_ERROR: '12',
    // 作業終了時刻チェック
    END_TIME_ERROR: '13'
  },

  /**
   * 予約編集結果コード
   * @name REQUEST_EDIT_RESULT
   * @constant
   * @memberOf const.ContractorConst
   */
  REQUEST_EDIT_RESULT: {
    // 成功
    SUCCESS: '1',
    // バース種別が無効
    INVALID_BERTH_CATEGORY: '2',
    // バースがすべて無効
    INVALID_BERTH: '3',
    // 利用可能日・時間外
    OUTSIDE: '4',
    // 予約枠超過
    FULL: '5',
    // 予約IDが無効
    INVALID_ID: '6',
    // 予約可能日範囲外
    BOOKING_PERIOD_OUTSIDE: '7',
    // 更新不可項目が含まれている
    UNEDITABLE_ITEM: '8',
    // その他エラ－
    OTHER: '9',
    // 配送会社名が無効
    CONTRACTOR_ID_ERROR: '10',
    // 予約期間エラー
    OUTSIDE_TIME: '11',
    // 開始予定時刻チェック
    START_TIME_ERROR: '12'
  },

  /**
   * 予約削除結果コード
   * @name REQUEST_DELETE_RESULT
   * @constant
   * @memberOf const.ContractorConst
   */
  REQUEST_DELETE_RESULT: {
    // 成功
    SUCCESS: '1',
    // 削除不可
    UNDELITEABLE: '2',
    // 削除不可ステータス
    INVALID_STATUS: '3',
    // その他
    OTHER: '9'
  }
};
export default ContractorConst;



// WEBPACK FOOTER //
// ./src/js/const/ContractorConst.jsx